<div class="analytics-widget" [ngClass]="{ centered: centered }">
  @if (loading) {
    <div class="loader">
      <div class="spinner-border" role="status"></div>
    </div>
  }
  @if (!loading && !hideNoData && (hasError || !result.rows.length)) {
    <div class="no-data-message">
      <p>{{ hasError ? ('ANALYTICS.ERROR_LOADING_DATA' | translate) : ('ANALYTICS.NO_DATA_AVAILABLE' | translate) }}</p>
    </div>
  }
  @if (!loading && (hideNoData || (!hasError && result.rows.length))) {
    <ng-container *ngTemplateOutlet="contentTemplate; context: context"></ng-container>
  }
</div>
